import { render } from "./TbsEponTable.vue?vue&type=template&id=7cbc181c&scoped=true"
import script from "./TbsEponTable.vue?vue&type=script&lang=js"
export * from "./TbsEponTable.vue?vue&type=script&lang=js"

import "./TbsEponTable.vue?vue&type=style&index=0&id=7cbc181c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbc181c"]])

export default __exports__